import React from "react";
import { ExternalLink } from "lucide-react";
import { MediaPreview } from "./StatusBadge";

function Line({ label, text }) {
  if (!text) return null;
  return <p className="text-xs text-white/85"><span className="mr-1 font-semibold uppercase tracking-wide text-[#F3D2D9]">{label}</span>{text}</p>;
}

export default function MediaCard({ testid, url, image, title, format, hook, cta, note, badge, actions, footer, onOpen }) {
  const stop = (e) => e.stopPropagation();
  return (
    <div data-testid={testid} onClick={onOpen} className={`group flex flex-col overflow-hidden rounded-[22px] bg-[#2D181E] shadow-card transition-transform hover:-translate-y-1 ${onOpen ? "cursor-pointer" : ""}`}>
      <div className="relative aspect-[9/16] overflow-hidden">
        <div className={`h-full w-full ${onOpen ? "pointer-events-none" : ""}`}><MediaPreview url={url} image={image} tall /></div>
        {badge && <span className="absolute left-3 top-3 rounded-full bg-white/95 px-2.5 py-1 text-[10px] font-medium text-bordeaux-dark shadow">{badge}</span>}
        {actions && <div onClick={stop} className="absolute right-3 top-3 flex gap-1 opacity-100 transition-opacity lg:opacity-0 lg:group-hover:opacity-100">{actions}</div>}
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex items-center justify-between gap-2">
          {format && <span className="rounded-full bg-bordeaux px-2.5 py-0.5 text-[10px] font-medium text-white">{format}</span>}
          {url && <a href={url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="inline-flex items-center gap-1 text-[11px] text-white/70 hover:text-white"><ExternalLink size={12} /> Voir le contenu</a>}
        </div>
        {title && <p className="text-sm font-medium text-white">{title}</p>}
        <Line label="Accroche" text={hook} />
        <Line label="CTA" text={cta} />
        {note && <p className="line-clamp-3 text-xs font-light italic text-white/60">{note}</p>}
        {onOpen && <span data-testid={testid && `${testid}-open`} className="text-[11px] font-medium text-[#F3D2D9] underline-offset-2 group-hover:underline">Voir le détail et les commentaires →</span>}
        {footer && <div onClick={stop} className="mt-auto border-t border-white/10 pt-3">{footer}</div>}
      </div>
    </div>
  );
}
